import Routers from "./routers";
import { useState, useEffect } from "react";
import Lenis from "lenis";
import './App.css';
import '../src/assets/css/blh6uew.css'
import '../src/assets/css/pipToggle.css'
import '../src/assets/css/videocontrols.css'
import "lenis/dist/lenis.css";
function App() {
    /* -----------------------------
     1️⃣ LENIS INIT (RUN ONCE)
  ----------------------------- */
  useEffect(() => {
    const lenis = new Lenis({
      duration: 2.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
      smoothTouch: true,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy(); // cleanup on unmount
    };
  }, []);

  return (
    <div className="App">
        <Routers/>
    </div>
  );
}

export default App;
